<script setup lang="ts">
defineProps<{
  hasSelection: boolean;
}>();

// biome-ignore lint/correctness/noUnusedVariables: used in <template>
const emit = defineEmits<{
  confirm: [];
}>();
</script>

<template>
  <div class="FacesIndividual__info">
    <h1 class="FacesIndividual__info-title kiosk-title">
      {{ $t('FacesIndividual.title') }}
    </h1>

    <button
      class="FacesIndividual__info-button kiosk-button kiosk-button--arrow-right"
      data-testid="faces-confirm"
      :disabled="!hasSelection"
      @click="emit('confirm')"
    >
      {{ $t('FacesIndividual.buttonConfirm') }}
    </button>
  </div>
</template>

<style lang="scss" scoped>
.FacesIndividual__info {
  width: var(--FacesIndividual__info-width);
  display: flex;
  flex-direction: column;
  align-items: var(--FacesIndividual__info-align-items);
  padding: var(--FacesIndividual__info-padding);
}

.FacesIndividual__info-title {
  text-align: var(--FacesIndividual__info-title-text-align);
  margin: var(--FacesIndividual__info-title-margin);
}

.FacesIndividual__info-button {
  margin-top: var(--FacesIndividual__info-button-margin-top);
}
</style>
